import { createRoot } from 'react-dom';
import OptInForm from './Components/OptInForm';
import UninstallSurvey from './Components/UninstallSurvey';
import './style.scss';

document.addEventListener('DOMContentLoaded', () => {
	console.log('FS-Lite: JS loaded, looking for roots...');

	// Render Opt-In Form (inline / standalone page mode)
	const optInRoots = document.querySelectorAll('.pev-fs-lite-root');
	optInRoots.forEach((root) => {
		if (root.dataset.info && !root.dataset.rendered) {
			const data = JSON.parse(root.dataset.info);
			createRoot(root).render(<OptInForm data={data} />);
			root.dataset.rendered = '1';
		}
	});

	// Render Opt-In Popup (hidden modal for the Plugins page Opt In link)
	const optInPopupRoots = document.querySelectorAll('.pev-fs-lite-popup-root');
	optInPopupRoots.forEach((root) => {
		if (root.dataset.info && !root.dataset.rendered) {
			const data = JSON.parse(root.dataset.info);
			createRoot(root).render(<OptInForm data={data} popup={true} />);
			root.dataset.rendered = '1';
		}
	});

	// Render Uninstall Survey
	const uninstallRoots = document.querySelectorAll('.pev-fs-lite-uninstall-root');
	uninstallRoots.forEach((root) => {
		if (root.dataset.info && !root.dataset.rendered) {
			const data = JSON.parse(root.dataset.info);
			createRoot(root).render(<UninstallSurvey data={data} />);
			root.dataset.rendered = '1';
		}
	});
});
